import{j as r}from"../../../react/jsx-runtime.js";import{createSvgIcon as a}from"@mui/material/utils";var t=a(r.jsx("path",{d:"m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"}),"ArrowForward");export{t as default};
//# sourceMappingURL=ArrowForward.js.map
